import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SseService } from 'src/app/services/SseService';

@Component({
  selector: 'app-descripcion-general',
  templateUrl: './descripcion-general.component.html',
  styleUrl: './descripcion-general.component.scss'
})
export class DescripcionGeneralComponent implements OnInit, OnChanges {
  
  @Input() compania: string = '';
  public dataCompania: any;

  constructor(private _sseService: SseService){
    
  }

  ngOnInit() {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['compania']) {

      let url2='v3/profile/'+changes['compania'].currentValue
      this._sseService.apiGetNew(url2).subscribe({
        next: (data: any)=>{
          this.dataCompania = data;
        }
      });
    }
  }

}
